import { useNavigate, generatePath } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Auth2FaProvider } from '../context/Auth2FaContext';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';
import { logout } from '@/store/actions/auth.actions';
import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';

import { SignInNavigation } from '@/pages/auth/SignInNavigation';
import { Loader } from '@/ui-kit/loader/Loader';

import { Auth2FaStepper } from './Auth2FaStepper';

export function Auth2Fa() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    accessTokenDecoded: { secureAuthentication },
    hasPassphrase,
    id: currentSupportUserId,
    shouldChangePassword,
  } = useCurrentSupportUser();
  const PathRoute = useRoutepaths();

  if (secureAuthentication && !shouldChangePassword) {
    return <SignInNavigation hasPassphrase={hasPassphrase} />;
  }

  if (!currentSupportUserId) {
    return <Loader />;
  }

  return (
    <Auth2FaProvider
      onBack={() => {
        dispatch(logout());
        navigate(generatePath(PathRoute.auth.root, { '*': PathRoute.auth.signIn }));
      }}
    >
      <Auth2FaStepper />
    </Auth2FaProvider>
  );
}
